// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2oCfq","text":"SelectPayment_text__swtMJ","title":"SelectPayment_title__2PfEb","btn":"SelectPayment_btn__3copv"};